'use strict';

angular.module('app')
    .controller('PrintController', ['$scope', '$stateParams', 'Recipe', 'Print', 'PrintService', '$q', 'PrinterConfig', '$filter', 'PreviousPageInfo', '$rootScope', '$state', '$translate', function ($scope, $stateParams, Recipe, Print, PrintService, $q, PrinterConfig, $filter, PreviousPageInfo, $rootScope, $state, $translate) {
        var isRecipe = !_.isNil($stateParams.id);
        //if the previous page info is not defined or it was some page other than search (like print history) we just default to the recipe
        if (isRecipe) {
            if (!PreviousPageInfo.name || PreviousPageInfo.name.indexOf('search') === -1) {
                PreviousPageInfo = {
                    name: 'recipe',
                    params: {id: $stateParams.id}
                };
            }
        } else if (!PreviousPageInfo.name) {
            PreviousPageInfo = {
                name: 'category',
                params: {id: ''}
            };
        }
        $scope.printSettings = {quantity: 1};
        $scope.currentBatchNumber = 1;
        $scope.labelType = 'new';

        var getExpireDate = function (date) {
            var shelfLifeQuantity = _.get($scope.recipe, 'shelfLifeQuantity');
            var shelfLifeUnit = _.get($scope.recipe, 'shelfLifeUnit');
            if (_.isNil(shelfLifeQuantity)) {
                return null;
            }
            if (shelfLifeUnit === 'HOUR') {
                date.setTime(date.getTime() + (shelfLifeQuantity * 60 * 60 * 1000));
            } else if (shelfLifeUnit === 'WEEK') {
                date.setDate(date.getDate() + (shelfLifeQuantity * 7));
            } else if (shelfLifeUnit === 'DAY') {
                date.setDate(date.getDate() + shelfLifeQuantity);
            } else {
                date = null;
            }
            return date;
        };

        var resetPrintSettings = function () {
            var now = new Date();
            $scope.printSettings = {
                prepDate: now,
                prepChef: '',
                notes: '',
                expireDate: getExpireDate(_.cloneDeep(now)),
                quantity: $scope.printSettings.quantity
            };
        };

        resetPrintSettings();

        $scope.onNewClicked = function () {
            if ($scope.labelType === 'new') {
                return;
            }
            resetPrintSettings();
            $scope.labelType = 'new';
            $scope.freshBatch = false;
            $scope.userSubmitted = false;
            $scope.printSettings.batchNumber = $scope.currentBatchNumber;
        };

        $scope.onFromBatchClicked = function () {
            if ($scope.labelType === 'fromBatch') {
                return;
            }
            resetPrintSettings();
            $scope.labelType = 'fromBatch';
            $scope.freshBatch = true;
            $scope.printSettings.batchNumber = null;
            $scope.userSubmitted = false;
            $scope.printSettings.prepChef = '';
        };

        $scope.onCancelClick = function () {
            $state.go(PreviousPageInfo.name, PreviousPageInfo.params);
        };

        $scope.getInvalidQuantity = function () {
            return _.isNil($scope.printSettings.quantity) || $scope.printSettings.quantity <= 0 || $scope.printSettings.quantity > 10;
        };

        $scope.onBatchNumberChanged = function (newBatchNumber) {
            if (newBatchNumber) {
                $scope.freshBatch = false;
                var foundHistory = _.find($scope.printHistory, function (history) {
                    return history.batchNumber === newBatchNumber;
                });
                foundHistory.prepDate = new Date(foundHistory.prepDate);
                if (foundHistory.expireDate) {
                    foundHistory.expireDate = new Date(foundHistory.expireDate);
                }
                $scope.printSettings = _.assign({}, $scope.printSettings, foundHistory);
            }
        };

        $scope.$watch('printSettings.quantity', function (newValue, oldValue) {
            if (oldValue !== newValue) {
                if (!_.isNil(newValue) && !_.isEmpty(newValue) && newValue <= 0) {
                    $scope.printSettings.quantity = 1;
                } else if (newValue > 99) {
                    $scope.printSettings.quantity = 99;
                }
            }
        });

        $scope.validate = function () {
            if (isRecipe) {
                if (_.isNil($scope.printSettings.prepChef) || _.isEmpty($scope.printSettings.prepChef)) {
                    return false;
                }
                if (_.isNil($scope.printSettings.batchNumber) || $scope.printSettings.batchNumber <= 0) {
                    return false;
                }
            }
            return !$scope.getInvalidQuantity();

        };

        $scope.submitPrintRequest = function () {
            $scope.userSubmitted = true;
            if (!$scope.validate()) {
                return;
            }
            var printInfo = _.assign({}, $scope.printSettings);
            printInfo.id = null;
            printInfo.recipe = $scope.recipe;
            printInfo.printerConfig = $scope.printerConfig;
            var prevPage = isRecipe ? PreviousPageInfo : null;
            PrintService.print(printInfo, _.get($scope, 'recipe.name'), prevPage);
        };

        var handlePrintHistory = function (printHistory, nextBatchNumber) {
            $scope.currentBatchNumber = nextBatchNumber;
            $scope.printHistory = _.map(printHistory, function (history) {
                history.batchNumberStr = history.batchNumber + ' - ' + $filter('dateFormatFilter')(new Date(history.prepDate));
                history.prepDate = new Date(history.prepDate);
                return history;
            });
            $scope.printSettings.batchNumber = $scope.currentBatchNumber;
        };

        $scope.getPrepChefs = function (search) {
            var retPrepChefs = _.clone($scope.prepChefs);
            if (!_.isEmpty(search) && !_.includes(retPrepChefs, search)) {
                retPrepChefs.unshift(search);
            }
            $scope.lastSearch = search;
            return retPrepChefs;
        };

        $scope.onPrepChefOpenClose = function (isOpen) {
            if (!isOpen) {
                //if we're closing the input and they didn't select anything, preserve their search as prep chef
                if (!$scope.printSettings.prepChef) {
                    $scope.printSettings.prepChef = $scope.lastSearch;
                }
            } else {
                $scope.printSettings.prepChef = '';
            }
        };

        var promises = isRecipe ?
            [
                Recipe.get({id: $stateParams.id}).$promise,
                Print.getBatchesPastMonth({id: $stateParams.id}).$promise,
                PrinterConfig.current().$promise,
                Print.getPrepChefs().$promise,
                Print.getNextBatchNumber().$promise
            ]
            : [PrinterConfig.current().$promise, Print.getPrepChefs().$promise];

        $q.all(promises).then(function (results) {
            var now = new Date();
            $scope.printSettings.prepDate = now;
            var printConfigIndex = 0;
            var prepChefResultIndex = 1;
            if (isRecipe) {
                $scope.recipe = results[0];
                if (($scope.recipe.type.category || $scope.recipe.category) !== 'PREPARED') {
                    bootbox.alert({
                        title: $translate.instant('recipeViewer.global.oops'),
                        message: $translate.instant('recipeViewer.print.onlyPreparedItemCanBePrint'),
                        callback: function () {
                            $state.go('recipe', {id: $scope.recipe.id});
                        },
                        buttons: {
                            ok: {
                                label: $translate.instant("recipeViewer.global.ok")
                            }
                        }
                    });
                }
                $scope.printSettings.expireDate = getExpireDate(_.cloneDeep(now));

                var nextBatchNumber = results[4].nextBatchNumber || 1;

                handlePrintHistory(results[1], nextBatchNumber);
                printConfigIndex = 2;
                prepChefResultIndex = 3;
            }
            $scope.printerConfig = results[printConfigIndex];
            $scope.prepChefs = _.chain(results[prepChefResultIndex])
                .uniqBy(function (chef) {
                    return chef.toLowerCase();
                }).sort().value();
        });
    }])
    .directive("digitsOnlyWithMaxDigitCount", [function () {
        return {
            restrict: "A",
            link: function (scope, elem, attrs) {
                var limit = parseInt(attrs.digitsOnlyWithMaxDigitCount);
                angular.element(elem).on("keypress", function (e) {
                    if (!/^\d+$/.test(String.fromCharCode(e.charCode))) {
                        e.preventDefault();
                    } else if (this.value.length === limit) {
                        e.preventDefault();
                    }
                });
            }
        };
    }])
    .directive('maxlen', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                var $uiSelect = angular.element(element[0].querySelector('.ui-select-search'));
                $uiSelect.attr("maxlength", attr.maxlen);
            }
        };
    });